import { Routes } from '@angular/router';
import { authGuard } from './services/auth.service';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/landing/landing.component').then(
        (m) => m.LandingComponent
      ),
    title: 'HNH Jewellery — Trendy Anti Tarnish Jewellery',
  },
  {
    path: 'shop',
    loadComponent: () =>
      import('./components/product-list/product-list.component').then(
        (m) => m.ProductListComponent
      ),
    title: 'Shop — HNH Jewellery',
  },
  { path: 'products', redirectTo: 'shop' },
  {
    path: 'collections',
    loadComponent: () =>
      import('./components/collections/collections.component').then(
        (m) => m.CollectionsComponent
      ),
    title: 'Collections — HNH Jewellery',
  },
  {
    path: 'product/:id',
    loadComponent: () =>
      import('./components/product-detail/product-detail.component').then(
        (m) => m.ProductDetailComponent
      ),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./components/about/about.component').then(
        (m) => m.AboutComponent
      ),
    title: 'About Us — HNH Jewellery',
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./components/contact/contact.component').then(
        (m) => m.ContactComponent
      ),
    title: 'Contact — HNH Jewellery',
  },
  {
    path: 'cart',
    loadComponent: () =>
      import('./components/cart/cart.component').then((m) => m.CartComponent),
    title: 'Your Cart — HNH Jewellery',
  },
  {
    path: 'checkout',
    loadComponent: () =>
      import('./components/checkout/checkout.component').then(
        (m) => m.CheckoutComponent
      ),
    title: 'Checkout — HNH Jewellery',
  },
  {
    path: 'wishlist',
    loadComponent: () =>
      import('./components/wishlist/wishlist.component').then(
        (m) => m.WishlistComponent
      ),
    title: 'Wishlist — HNH Jewellery',
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./components/admin-login/admin-login.component').then(
        (m) => m.AdminLoginComponent
      ),
    title: 'Admin Login — HNH Jewellery',
  },
  {
    path: 'admin/dashboard',
    loadComponent: () =>
      import('./components/admin-dashboard/admin-dashboard.component').then(
        (m) => m.AdminDashboardComponent
      ),
    canActivate: [authGuard],
    title: 'Admin Dashboard — HNH Jewellery',
  },
  { path: '**', redirectTo: '' },
];
